import React from "react";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material";
import { useSelector } from "react-redux";
import SidebarItems from "../SidebarItems";

const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const DeskDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DesktopDrawer = (props) => {
  const { isOpen } = useSelector((state) => state.sidebar);
  return (
    <DeskDrawer
      variant="permanent"
      open={isOpen}
      sx={{
        display: { xs: "none", md: "block" },
        "& .MuiDrawer-paper": {
          marginTop: "65px",
          paddingTop: "45px",
          paddingBottom: "80px",
          overflowY: "auto",
          boxShadow: "0 0.5rem 1rem 0 rgb(44 51 73 / 10%)",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "0.3em",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "scrollbar.secondary",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "scrollbar.primary",
            borderRadius: "3rem",
          },
        },
      }}
    >
      <SidebarItems />
    </DeskDrawer>
  );
};

export default DesktopDrawer;
